// extracted by mini-css-extract-plugin
export default {"getstartedcont":"Getstarted_getstartedcont__TyOic","Getstarted":"Getstarted_Getstarted__W0cj4","cont":"Getstarted_cont__G0yy-"};